'use client';
"use strict";

var _excluded = ["defaultIndex", "onChange", "index", "isManual", "isLazy", "lazyBehavior", "orientation", "direction"],
  _excluded2 = ["isDisabled", "isFocusable"],
  _excluded3 = ["children"],
  _excluded4 = ["children", "className"],
  _excluded5 = ["htmlProps", "descendants"],
  _excluded6 = ["isFitted"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Tab: function Tab() {
    return _Tab;
  },
  TabIndicator: function TabIndicator() {
    return _TabIndicator;
  },
  TabList: function TabList() {
    return _TabList;
  },
  TabPanel: function TabPanel() {
    return _TabPanel;
  },
  TabPanels: function TabPanels() {
    return _TabPanels;
  },
  Tabs: function Tabs() {
    return _Tabs;
  },
  TabsDescendantsProvider: function TabsDescendantsProvider() {
    return _TabsDescendantsProvider;
  },
  TabsProvider: function TabsProvider() {
    return _TabsProvider;
  },
  useTab: function useTab() {
    return _useTab;
  },
  useTabIndicator: function useTabIndicator() {
    return _useTabIndicator;
  },
  useTabList: function useTabList() {
    return _useTabList;
  },
  useTabPanel: function useTabPanel() {
    return _useTabPanel;
  },
  useTabPanels: function useTabPanels() {
    return _useTabPanels;
  },
  useTabs: function useTabs() {
    return _useTabs;
  },
  useTabsContext: function useTabsContext() {
    return _useTabsContext;
  },
  useTabsDescendant: function useTabsDescendant() {
    return _useTabsDescendant;
  },
  useTabsDescendants: function useTabsDescendants() {
    return _useTabsDescendants;
  },
  useTabsDescendantsContext: function useTabsDescendantsContext() {
    return _useTabsDescendantsContext;
  },
  useTabsStyles: function useTabsStyles() {
    return _useTabsStyles;
  }
});
module.exports = __toCommonJS(src_exports);

// src/tab.tsx
var import_shared_utils3 = require("@chakra-ui/shared-utils");
var import_system2 = require("@chakra-ui/system");

// src/tabs.tsx
var import_react_context2 = require("@chakra-ui/react-context");
var import_system = require("@chakra-ui/system");
var import_shared_utils2 = require("@chakra-ui/shared-utils");
var import_react2 = require("react");

// src/use-tabs.ts
var import_clickable = require("@chakra-ui/clickable");
var import_descendant = require("@chakra-ui/descendant");
var import_react_context = require("@chakra-ui/react-context");
var import_react_use_safe_layout_effect = require("@chakra-ui/react-use-safe-layout-effect");
var import_react_use_controllable_state = require("@chakra-ui/react-use-controllable-state");
var import_react_children_utils = require("@chakra-ui/react-children-utils");
var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");
var import_lazy_utils = require("@chakra-ui/lazy-utils");
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_react = require("react");
var _ref = (0, import_descendant.createDescendantContext)(),
  _ref2 = _slicedToArray(_ref, 4),
  _TabsDescendantsProvider = _ref2[0],
  _useTabsDescendantsContext = _ref2[1],
  _useTabsDescendants = _ref2[2],
  _useTabsDescendant = _ref2[3];
function _useTabs(props) {
  var _a;
  var defaultIndex = props.defaultIndex,
    onChange = props.onChange,
    index = props.index,
    isManual = props.isManual,
    isLazy = props.isLazy,
    _props$lazyBehavior = props.lazyBehavior,
    lazyBehavior = _props$lazyBehavior === void 0 ? "unmount" : _props$lazyBehavior,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? "ltr" : _props$direction,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var _ref3 = (0, import_react.useState)(defaultIndex != null ? defaultIndex : 0),
    _ref4 = _slicedToArray(_ref3, 2),
    focusedIndex = _ref4[0],
    setFocusedIndex = _ref4[1];
  var _ref5 = (0, import_react_use_controllable_state.useControllableState)({
      defaultValue: defaultIndex != null ? defaultIndex : 0,
      value: index,
      onChange: onChange
    }),
    _ref6 = _slicedToArray(_ref5, 2),
    selectedIndex = _ref6[0],
    setSelectedIndex = _ref6[1];
  (0, import_react.useEffect)(function () {
    if (index != null) {
      setFocusedIndex(index);
    }
  }, [index]);
  var descendants = _useTabsDescendants();
  var uuid = (0, import_react.useId)();
  var uid = (_a = props.id) != null ? _a : uuid;
  var id = "tabs-".concat(uid);
  return {
    id: id,
    selectedIndex: selectedIndex,
    focusedIndex: focusedIndex,
    setSelectedIndex: setSelectedIndex,
    setFocusedIndex: setFocusedIndex,
    isManual: isManual,
    isLazy: isLazy,
    lazyBehavior: lazyBehavior,
    orientation: orientation,
    descendants: descendants,
    direction: direction,
    htmlProps: htmlProps
  };
}
var _ref7 = (0, import_react_context.createContext)({
    name: "TabsContext",
    errorMessage: "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />"
  }),
  _ref8 = _slicedToArray(_ref7, 2),
  _TabsProvider = _ref8[0],
  _useTabsContext = _ref8[1];
function _useTabList(props) {
  var _useTabsContext2 = _useTabsContext(),
    focusedIndex = _useTabsContext2.focusedIndex,
    orientation = _useTabsContext2.orientation,
    direction = _useTabsContext2.direction;
  var descendants = _useTabsDescendantsContext();
  var onKeyDown = (0, import_react.useCallback)(function (event) {
    var nextTab = function nextTab() {
      var _a;
      var next = descendants.nextEnabled(focusedIndex);
      if (next) (_a = next.node) == null ? void 0 : _a.focus();
    };
    var prevTab = function prevTab() {
      var _a;
      var prev = descendants.prevEnabled(focusedIndex);
      if (prev) (_a = prev.node) == null ? void 0 : _a.focus();
    };
    var firstTab = function firstTab() {
      var _a;
      var first = descendants.firstEnabled();
      if (first) (_a = first.node) == null ? void 0 : _a.focus();
    };
    var lastTab = function lastTab() {
      var _a;
      var last = descendants.lastEnabled();
      if (last) (_a = last.node) == null ? void 0 : _a.focus();
    };
    var isHorizontal = orientation === "horizontal";
    var isVertical = orientation === "vertical";
    var eventKey = event.key;
    var ArrowStart = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
    var ArrowEnd = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
    var keyMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ArrowStart, function () {
      return isHorizontal && prevTab();
    }), ArrowEnd, function () {
      return isHorizontal && nextTab();
    }), "ArrowDown", function ArrowDown() {
      return isVertical && nextTab();
    }), "ArrowUp", function ArrowUp() {
      return isVertical && prevTab();
    }), "Home", firstTab), "End", lastTab);
    var action = keyMap[eventKey];
    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [descendants, focusedIndex, orientation, direction]);
  return _objectSpread(_objectSpread({}, props), {}, {
    role: "tablist",
    "aria-orientation": orientation,
    onKeyDown: (0, import_shared_utils.callAllHandlers)(props.onKeyDown, onKeyDown)
  });
}
function _useTab(props) {
  var _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$isFocusable = props.isFocusable,
    isFocusable = _props$isFocusable === void 0 ? false : _props$isFocusable,
    htmlProps = _objectWithoutProperties(props, _excluded2);
  var _useTabsContext3 = _useTabsContext(),
    setSelectedIndex = _useTabsContext3.setSelectedIndex,
    isManual = _useTabsContext3.isManual,
    id = _useTabsContext3.id,
    setFocusedIndex = _useTabsContext3.setFocusedIndex,
    selectedIndex = _useTabsContext3.selectedIndex;
  var _useTabsDescendant2 = _useTabsDescendant({
      disabled: isDisabled && !isFocusable
    }),
    index = _useTabsDescendant2.index,
    register = _useTabsDescendant2.register;
  var isSelected = index === selectedIndex;
  var onClick = function onClick() {
    setSelectedIndex(index);
  };
  var onFocus = function onFocus() {
    setFocusedIndex(index);
    var isDisabledButFocusable = isDisabled && isFocusable;
    var shouldSelect = !isManual && !isDisabledButFocusable;
    if (shouldSelect) {
      setSelectedIndex(index);
    }
  };
  var clickableProps = (0, import_clickable.useClickable)(_objectSpread(_objectSpread({}, htmlProps), {}, {
    ref: (0, import_react_use_merge_refs.mergeRefs)(register, props.ref),
    isDisabled: isDisabled,
    isFocusable: isFocusable,
    onClick: (0, import_shared_utils.callAllHandlers)(props.onClick, onClick)
  }));
  var type = "button";
  return _objectSpread(_objectSpread({}, clickableProps), {}, {
    id: makeTabId(id, index),
    role: "tab",
    tabIndex: isSelected ? 0 : -1,
    type: type,
    "aria-selected": isSelected,
    "aria-controls": makeTabPanelId(id, index),
    onFocus: isDisabled ? void 0 : (0, import_shared_utils.callAllHandlers)(props.onFocus, onFocus)
  });
}
var _ref9 = (0, import_react_context.createContext)({}),
  _ref10 = _slicedToArray(_ref9, 2),
  TabPanelProvider = _ref10[0],
  useTabPanelContext = _ref10[1];
function _useTabPanels(props) {
  var context = _useTabsContext();
  var id = context.id,
    selectedIndex = context.selectedIndex;
  var validChildren = (0, import_react_children_utils.getValidChildren)(props.children);
  var children = validChildren.map(function (child, index) {
    return (0, import_react.createElement)(TabPanelProvider, {
      key: index,
      value: {
        isSelected: index === selectedIndex,
        id: makeTabPanelId(id, index),
        tabId: makeTabId(id, index),
        selectedIndex: selectedIndex
      }
    }, child);
  });
  return _objectSpread(_objectSpread({}, props), {}, {
    children: children
  });
}
function _useTabPanel(props) {
  var children = props.children,
    htmlProps = _objectWithoutProperties(props, _excluded3);
  var _useTabsContext4 = _useTabsContext(),
    isLazy = _useTabsContext4.isLazy,
    lazyBehavior = _useTabsContext4.lazyBehavior;
  var _useTabPanelContext = useTabPanelContext(),
    isSelected = _useTabPanelContext.isSelected,
    id = _useTabPanelContext.id,
    tabId = _useTabPanelContext.tabId;
  var hasBeenSelected = (0, import_react.useRef)(false);
  if (isSelected) {
    hasBeenSelected.current = true;
  }
  var shouldRenderChildren = (0, import_lazy_utils.lazyDisclosure)({
    wasSelected: hasBeenSelected.current,
    isSelected: isSelected,
    enabled: isLazy,
    mode: lazyBehavior
  });
  return _objectSpread(_objectSpread({
    // Puts the tabpanel in the page `Tab` sequence.
    tabIndex: 0
  }, htmlProps), {}, {
    children: shouldRenderChildren ? children : null,
    role: "tabpanel",
    "aria-labelledby": tabId,
    hidden: !isSelected,
    id: id
  });
}
function _useTabIndicator() {
  var context = _useTabsContext();
  var descendants = _useTabsDescendantsContext();
  var selectedIndex = context.selectedIndex,
    orientation = context.orientation;
  var isHorizontal = orientation === "horizontal";
  var isVertical = orientation === "vertical";
  var _ref11 = (0, import_react.useState)(function () {
      if (isHorizontal) return {
        left: 0,
        width: 0
      };
      if (isVertical) return {
        top: 0,
        height: 0
      };
      return void 0;
    }),
    _ref12 = _slicedToArray(_ref11, 2),
    rect = _ref12[0],
    setRect = _ref12[1];
  var _ref13 = (0, import_react.useState)(false),
    _ref14 = _slicedToArray(_ref13, 2),
    hasMeasured = _ref14[0],
    setHasMeasured = _ref14[1];
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(function () {
    if (selectedIndex == null) return;
    var tab = descendants.item(selectedIndex);
    if (tab == null) return;
    if (isHorizontal) {
      setRect({
        left: tab.node.offsetLeft,
        width: tab.node.offsetWidth
      });
    }
    if (isVertical) {
      setRect({
        top: tab.node.offsetTop,
        height: tab.node.offsetHeight
      });
    }
    var id = requestAnimationFrame(function () {
      setHasMeasured(true);
    });
    return function () {
      if (id) {
        cancelAnimationFrame(id);
      }
    };
  }, [selectedIndex, isHorizontal, isVertical, descendants]);
  return _objectSpread({
    position: "absolute",
    transitionProperty: "left, right, top, bottom, height, width",
    transitionDuration: hasMeasured ? "200ms" : "0ms",
    transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)"
  }, rect);
}
function makeTabId(id, index) {
  return "".concat(id, "--tab-").concat(index);
}
function makeTabPanelId(id, index) {
  return "".concat(id, "--tabpanel-").concat(index);
}

// src/tabs.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var _ref15 = (0, import_react_context2.createContext)({
    name: "TabsStylesContext",
    errorMessage: "useTabsStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Tabs />\" "
  }),
  _ref16 = _slicedToArray(_ref15, 2),
  TabsStylesProvider = _ref16[0],
  _useTabsStyles = _ref16[1];
var _Tabs = (0, import_system.forwardRef)(function Tabs2(props, ref) {
  var styles = (0, import_system.useMultiStyleConfig)("Tabs", props);
  var _ref17 = (0, import_system.omitThemingProps)(props),
    children = _ref17.children,
    className = _ref17.className,
    rest = _objectWithoutProperties(_ref17, _excluded4);
  var _useTabs2 = _useTabs(rest),
    htmlProps = _useTabs2.htmlProps,
    descendants = _useTabs2.descendants,
    ctx = _objectWithoutProperties(_useTabs2, _excluded5);
  var context = (0, import_react2.useMemo)(function () {
    return ctx;
  }, [ctx]);
  var _ = htmlProps.isFitted,
    rootProps = _objectWithoutProperties(htmlProps, _excluded6);
  var tabsStyles = _objectSpread({
    position: "relative"
  }, styles.root);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(_TabsDescendantsProvider, {
    value: descendants,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(_TabsProvider, {
      value: context,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(TabsStylesProvider, {
        value: styles,
        children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({
          className: (0, import_shared_utils2.cx)("chakra-tabs", className),
          ref: ref
        }, rootProps), {}, {
          __css: tabsStyles,
          children: children
        }))
      })
    })
  });
});
_Tabs.displayName = "Tabs";

// src/tab.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var _Tab = (0, import_system2.forwardRef)(function Tab2(props, ref) {
  var styles = _useTabsStyles();
  var tabProps = _useTab(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
  var tabStyles = _objectSpread({
    outline: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, styles.tab);
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.button, _objectSpread(_objectSpread({}, tabProps), {}, {
    className: (0, import_shared_utils3.cx)("chakra-tabs__tab", props.className),
    __css: tabStyles
  }));
});
_Tab.displayName = "Tab";

// src/tab-indicator.tsx
var import_shared_utils4 = require("@chakra-ui/shared-utils");
var import_system3 = require("@chakra-ui/system");
var import_jsx_runtime3 = require("react/jsx-runtime");
var _TabIndicator = (0, import_system3.forwardRef)(function TabIndicator2(props, ref) {
  var indicatorStyle = _useTabIndicator();
  var style = _objectSpread(_objectSpread({}, props.style), indicatorStyle);
  var styles = _useTabsStyles();
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_system3.chakra.div, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: (0, import_shared_utils4.cx)("chakra-tabs__tab-indicator", props.className),
    style: style,
    __css: styles.indicator
  }));
});
_TabIndicator.displayName = "TabIndicator";

// src/tab-list.tsx
var import_shared_utils5 = require("@chakra-ui/shared-utils");
var import_system4 = require("@chakra-ui/system");
var import_jsx_runtime4 = require("react/jsx-runtime");
var _TabList = (0, import_system4.forwardRef)(function TabList2(props, ref) {
  var tablistProps = _useTabList(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
  var styles = _useTabsStyles();
  var tablistStyles = _objectSpread({
    display: "flex"
  }, styles.tablist);
  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system4.chakra.div, _objectSpread(_objectSpread({}, tablistProps), {}, {
    className: (0, import_shared_utils5.cx)("chakra-tabs__tablist", props.className),
    __css: tablistStyles
  }));
});
_TabList.displayName = "TabList";

// src/tab-panel.tsx
var import_shared_utils6 = require("@chakra-ui/shared-utils");
var import_system5 = require("@chakra-ui/system");
var import_jsx_runtime5 = require("react/jsx-runtime");
var _TabPanel = (0, import_system5.forwardRef)(function TabPanel2(props, ref) {
  var panelProps = _useTabPanel(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
  var styles = _useTabsStyles();
  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system5.chakra.div, _objectSpread(_objectSpread({
    outline: "0"
  }, panelProps), {}, {
    className: (0, import_shared_utils6.cx)("chakra-tabs__tab-panel", props.className),
    __css: styles.tabpanel
  }));
});
_TabPanel.displayName = "TabPanel";

// src/tab-panels.tsx
var import_shared_utils7 = require("@chakra-ui/shared-utils");
var import_system6 = require("@chakra-ui/system");
var import_jsx_runtime6 = require("react/jsx-runtime");
var _TabPanels = (0, import_system6.forwardRef)(function TabPanels2(props, ref) {
  var panelsProps = _useTabPanels(props);
  var styles = _useTabsStyles();
  return /* @__PURE__ */(0, import_jsx_runtime6.jsx)(import_system6.chakra.div, _objectSpread(_objectSpread({}, panelsProps), {}, {
    width: "100%",
    ref: ref,
    className: (0, import_shared_utils7.cx)("chakra-tabs__tab-panels", props.className),
    __css: styles.tabpanels
  }));
});
_TabPanels.displayName = "TabPanels";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Tab: _Tab,
  TabIndicator: _TabIndicator,
  TabList: _TabList,
  TabPanel: _TabPanel,
  TabPanels: _TabPanels,
  Tabs: _Tabs,
  TabsDescendantsProvider: _TabsDescendantsProvider,
  TabsProvider: _TabsProvider,
  useTab: _useTab,
  useTabIndicator: _useTabIndicator,
  useTabList: _useTabList,
  useTabPanel: _useTabPanel,
  useTabPanels: _useTabPanels,
  useTabs: _useTabs,
  useTabsContext: _useTabsContext,
  useTabsDescendant: _useTabsDescendant,
  useTabsDescendants: _useTabsDescendants,
  useTabsDescendantsContext: _useTabsDescendantsContext,
  useTabsStyles: _useTabsStyles
});